import { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import axios from "axios";
import Navbar from "../../component/Navbar";
import Footer from "../../component/Footer";
import BookWithUs from "../../component/BookWithUs";
import Faq from "../../component/Faq";
import PackageForm from "./VisitorComp/PackageForm";
import { baseurl, imageUrl } from "../../component/Baseurl";

function PackageDetailsTwo() {
  const { slug } = useParams(); // Get slug from URL params
  const [packageData, setPackageData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchPackageDetails = async () => {
      try {
        const response = await axios.get(`${baseurl}/GetPackageBySlug/${slug}`);
        setPackageData(response.data.package);
      } catch (error) {
        console.error("Error fetching package:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchPackageDetails();
  }, [slug]);

  if (loading) {
    return <p>Loading package details...</p>;
  }

  if (!packageData) {
    return <p>Package not found.</p>;
  }

  return (
    <>
      <Navbar />
      <div className="package-details-container">
        <div className="image-container">
          <img
            src={`${imageUrl}packages/${packageData.banner_image}`}
            className="img-fluid imgpackage2"
            alt={packageData.package_name}
          />
        </div>
      </div>

      <div className="container my-4">
        <div className="row text-start">
          <div className="col-md-8">
            <h2 className="package-title1">{packageData.package_name}</h2>
            <p>{packageData.package_description}</p>

            {/* Loop through package_details and display key-value pairs */}
            {packageData.package_details.map((detail, index) => (
              <div key={index} className="text-start mb-3">
                <h4 className="txt5">{detail.key_name}</h4>
                <p>{detail.value}</p>
              </div>
            ))}
          </div>

          <div className="col-md-4">
            <PackageForm packageid = {packageData.id} />
          </div>
        </div>
      </div>

      <BookWithUs />
      <Faq />
      <Footer />
    </>
  );
}

export default PackageDetailsTwo;
